<template>
  <fieldset>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Bas-URL</div>
      </div>
      <input type="url" class="form-control" required pattern="https://.+" v-model="baseUrl" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">ClientId</div>
      </div>
      <input type="text" class="form-control" required v-model="clientId" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">ClientSecret</div>
      </div>
      <input type="text" class="form-control" required v-model="clientSecret" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Användarnamn</div>
      </div>
      <input type="text" class="form-control" required v-model="username" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Lösenord</div>
      </div>
      <input type="text" class="form-control" required v-model="password" @input="onUpdate">
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const baseUrl = ref(null);
const clientId = ref(null);
const clientSecret = ref(null);
const username = ref(null);
const password = ref(null);
const serializedValue = computed(() => {
  return {
    base_url: baseUrl.value,
    client_id: clientId.value,
    client_secret: clientSecret.value,
    username: username.value,
    password: password.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    baseUrl.value = modelValue.value.base_url;
    clientId.value = modelValue.value.client_id;
    clientSecret.value = modelValue.value.client_secret;
    username.value = modelValue.value.username;
    password.value = modelValue.value.password;
  }
}, {
  immediate: true
});
</script>
